/*
  ptu-media — media panel for the PDP V2 Two Up section.

  The image is the base layer and always renders. When a video is also set it
  sits on top at opacity 0 and is revealed only once it can actually play, so a
  slow or failed video leaves the image in place rather than a black rectangle.

  Reduced motion wins outright: autoplay is stripped and the video is never
  revealed, so the image stands in. Guarding in JS as well as CSS matters here
  because CSS cannot stop a video from autoplaying.

  No shopify:section:load listener is needed. Custom elements upgrade when the
  theme editor injects new markup, so connectedCallback runs on its own.
*/
class PtuMedia extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector('video');
    if (!video) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.removeAttribute('autoplay');
      video.pause();
      return;
    }

    const reveal = () => this.classList.add('is-video-ready');

    // readyState 3 is HAVE_FUTURE_DATA, which is what `canplay` fires on. A
    // cached video can reach it before this element upgrades.
    if (video.readyState >= 3) {
      reveal();
    } else {
      video.addEventListener('canplay', reveal, { once: true });
    }

    video.addEventListener(
      'error',
      () => this.classList.remove('is-video-ready'),
      { once: true }
    );
  }
}

if (!customElements.get('ptu-media')) {
  customElements.define('ptu-media', PtuMedia);
}
